import {Component, OnInit, Input} from '@angular/core';
import { ProfileHttp } from '../../../tsScripts/providers/http/ProfileHttp';
import { ErrorDTO } from '../../../tsScripts/DTO/ErrorDTO';
import { MessageStorage } from '../../../tsScripts/util/MessageStorage';
// import { ProfileModel } from './MyProfile';

@Component({
    selector: 'profile-security',
    templateUrl: "../../../views/components/myProfile/profileSecurity.html",
    providers: [],
    styleUrls: ["../../../styles/agent.css"]
})

export class ProfileSecurity implements OnInit {

    @Input()
    profileModel: any;

    alertMessage: string;
    typeAlert: string;
    oldPassword: string;
    firstPassword: string;
    secondPassword: string;
    loading: boolean;
    politicsText: any;
    constructor(private ProfileHttp: ProfileHttp) {
        this.loading = false;
        this.alertMessage = "";
        this.typeAlert = "";
    }

    private changePassword() {
        this.typeAlert = "";
        this.alertMessage = "";
        let param: any = {
            oldPassword: this.oldPassword,
            newPassword: this.firstPassword,
            textmessage: '1'
        }
        this.ProfileHttp.changePassword(param).then((response: any) => {
            this.loading = false;
            if (response.error && response.error !== undefined) {
                this.typeAlert = "error";
                this.alertMessage = response.message;
            } else {
                MessageStorage.add("success", "Contraseña actualizada con éxito");
                this.cleanPasswords();
            }
        }, (error: ErrorDTO) => {
            this.loading = false;
            this.typeAlert = "error";
            this.alertMessage = error.errorMessage;
        });
    }

    validatePasswords() {
        this.loading = true;
        if (this.firstPassword !== this.secondPassword) {
            this.alertMessage = "Las contraseñas no coinciden";
            this.typeAlert = "error";
            this.loading = false;
        } else if (this.firstPassword.length > 100 && this.secondPassword.length > 100) {
            this.alertMessage = "La contraseña debe ser menor a 100 caracteres";
            this.typeAlert = "error";
            this.loading = false;
        } else {
            this.changePassword()
        }
    }

    cleanPasswords() {
        this.oldPassword = "";
        this.firstPassword = "";
        this.secondPassword = "";
    }

    getSecurityPolitics() {
        this.typeAlert = "";
        this.alertMessage = "";
        let param: any = {
            oldPassword: '',
            newPassword: '',
            textmessage: '0'
        }
        this.ProfileHttp.changePassword(param).then((response: any) => {
            this.loading = false;
            if (response.error && response.error !== undefined) {
               // this.cleanPasswords(false);
               this.politicsText = response.message;
            //    console.log(response);
            }
        }, (error: any) => {
            MessageStorage.add("error", error.errorMessage);
            // this.politicsText = error.errorMessage;
        });
    }

    ngOnInit() {
        this.getSecurityPolitics();
    }
}